import call from "../../service/http";
import { AuthService } from "../auth";
import ActivationConstants from "./ActivationConstants";

export default {
  namespaced: true,
  state: {
    loading: false,
    error: "",
    message: "",
    OTP_CODE: 0,
    verify: false,
    searchResults: {},
    activationResults: {},
    loadingactv: false,
    loadingVerify: false,
    resendLoading: false,
  },
  mutations: {
    DISPLAY_MESSAGE: (state, payload) => {
      state.resMessageShow = true;
      state.resError = false;
      state.resMessage = payload;
    },

    DISPLAY_ERROR_MESSAGE: (state, payload) => {
      state.resMessageShow = true;
      state.resError = true;
      state.resErrorMessage = payload;
    },

    REMEMBER_OTP_CODE: (state, payload) => {
      state.OTP_CODE = payload.OTP_CODE;
      state.phoneSession = payload.phone;
      state.verify = true;
    },

    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    activationGetter: (state) => (value) => state[value],
  },
  actions: {
    activate: ({ commit }, data) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ActivationConstants.activateRequest, data)
        .then((res) => {
          console.log(res.data.data);
          commit("MUTATE", { state: "activationResults", data: res.data.data });
          Event.$emit(
            "ApiSuccess",
            "Check your email or phone for the activation code",
          );
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", err.response.data.message);
        });
    },

    // verifying otp code
    verifyOtpCode: (context, data) => {
      context.commit("MUTATE", { state: "loadingVerify", data: true });
      call("post", ActivationConstants.verify, data)
        .then((res) => {
          AuthService.login(res.data.token, res.data.user);
          Event.$emit("ApiSuccess", res.data.message);
          context.commit("MUTATE", { state: "loadingVerify", data: false });
          Event.$emit("login");
          context.dispatch("CloseVerify");
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          context.commit("MUTATE", { state: "loadingVerify", data: false });
          context.commit("DISPLAY_ERROR_MESSAGE", "Invalid Code");
        });
    },

    resendOTP: (context, data) => {
      context.commit("MUTATE", { state: "resendLoading", data: true });
      call("post", ActivationConstants.resend, data)
        .then((res) => {
          Event.$emit("ApiInfo", "Code resent");
          context.commit("REMEMBER_OTP_CODE", res.data);
          context.commit("MUTATE", { state: "resendLoading", data: false });
          context.commit("MUTATE", {
            state: "isOnLogin",
            data: { show: false, code: "" },
          });
        })
        .catch((err) => {
          context.commit("MUTATE", { state: "resendLoading", data: false });
          Event.$emit("ApiError", err.response.data.message);
          console.log(err);
        });
    },

    searchStudent: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ActivationConstants.searchStudent(payload))
        .then((res) => {
          const data = { ...res.data.data[0] };
          commit("MUTATE", { state: "searchResults", data });
          Event.$emit(
            res.data.data.length !== 0 ? "ApiSuccess" : "ApiInfo",
            res.data.data.length !== 0 ? "Success" : "Student not Found",
          );
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },

    activateWithOtp: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", ActivationConstants.activateWithOtp, payload)
        .then((res) => {
          /** automatic login */
          Event.$emit(
            "ApiSuccess",
            "Activation Code verified, Password set successfully, logging in ...",
          );
          AuthService.login(res.data.data.token, res.data.data.user);
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },

    cancelActivation: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", ActivationConstants.cancelActivation(payload))
        .then(() => {
          Event.$emit("ApiSuccess", "Activation Cancelled Successfully");
          commit("Dashboard/SET_LOADING", false, { root: true });
          setTimeout(() => {
            Event.$emit("back-landing");
          }, 2500);
        })
        .catch((err) => {
          Event.$emit("ApiError", err.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
